import { useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";

/**
 * DOMの構造上ScrollWatcherが使えないときに、
 * 特定のoverflow=auto,scrollなコンテンツが末尾までスクロールされた時のイベント
 */
type UseOnScrollContentBottomProps = {
  rootContentWithScroll: HTMLDivElement | null;
  onScrollContentBottom: () => void;
};

export const useOnScrollContentBottom = ({
  onScrollContentBottom,
  rootContentWithScroll,
}: UseOnScrollContentBottomProps) => {
  const inViewTrackerRef = useRef(false);
  const { ref, inView, entry } = useInView({
    root: rootContentWithScroll,
  });

  useEffect(() => {
    // 末尾までスクロールした時コールバックは一度だけ実行する
    if (!inViewTrackerRef.current && inView) {
      onScrollContentBottom();
      inViewTrackerRef.current = true;
    }
  }, [inView]);

  useEffect(() => {
    // 末尾のエレメントが更新された時(APIのレスポンスによりエレメントが追加された時)
    // コールバックのストッパーをリセット
    if (entry?.target) {
      inViewTrackerRef.current = false;
    }
  }, [entry?.target]);

  return {
    refLastElement: ref,
  };
};
